<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents" id="rw-frontmatter-TableOfContents_41840-00001">
<div class="media image align-center">
<div class="pc">
<p style="text-align: center;"><img alt="Cover Image" src="welcome_image_online.jpg"/>
</p>
</div>
</div>
<div class="block toc" id="rw-block-toc_41840-00001">
<div class="block list-toc" id="rw-block-list-toc_41840-00001">
<div>
<p class="toc-bm" style="text-align: center;"><span class="toc-title"><a href="#/9780316187466_chapter_01#rw-title-block_41832-00001">Begin Reading</a> </span>
</p>
<p class="toc-bm" style="text-align: center;"><span class="toc-title"><span href="#/9780316187466_abouttheauthor#rw-title-block_41833-00001" title="Link target outside of Sample">Meet the Author</span> </span>
</p>
<p class="toc-bm" style="text-align: center;"><span class="toc-title"><span href="#/9780316187466_teaser#rw-title-block_41836-00001" title="Link target outside of Sample">Bonus Material</span> </span>
</p>
<p class="toc-bm" style="text-align: center;"><span class="toc-title"><span href="#/9780316187466_allpurpose#rw-title-block_41837-00001" title="Link target outside of Sample">About Orbit Short Fiction</span> </span>
</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780316187466_tableofcontents.vue?5eee4746